"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeedmapsProductDto = exports.WeedmapsBrandDto = void 0;
class WeedmapsBrandDto {
}
exports.WeedmapsBrandDto = WeedmapsBrandDto;
class WeedmapsProductDto {
}
exports.WeedmapsProductDto = WeedmapsProductDto;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2VlZG1hcHNCcmFuZER0by5qcyIsInNvdXJjZVJvb3QiOiIuL3NyYy8iLCJzb3VyY2VzIjpbInBhY2thZ2VzL21vZGVscy9kdG8vd2VlZG1hcHNCcmFuZER0by50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFhLGdCQUFnQjtDQUc1QjtBQUhELDRDQUdDO0FBRUQsTUFBYSxrQkFBa0I7Q0FHOUI7QUFIRCxnREFHQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBXZWVkbWFwc0JyYW5kRHRvIHtcbiAgICBpZDogbnVtYmVyO1xuICAgIHZhbHVlOiBzdHJpbmc7XG59XG5cbmV4cG9ydCBjbGFzcyBXZWVkbWFwc1Byb2R1Y3REdG8ge1xuICAgIGlkOiBudW1iZXI7XG4gICAgbmFtZTogc3RyaW5nO1xufSJdfQ==